import { Input } from 'antd';
import { isSecretAuthKey } from 'src/_shared/services/claus/constants';

// Renders the template's auth schema as a side-by-side field grid. In edit mode every field is a
// masked password input that starts blank with a "keep existing" placeholder (serde drops empties so
// unchanged secrets are never re-sent, and the stored secret is never rendered back). In create mode
// only secret-looking keys are masked.
export default function CredentialsSection({ template, authParams, onChange, isEdit }) {
	const auth = authParams || {};
	const set = (key, value) => onChange({ ...auth, [key]: value });

	const required = template?.authSchemaV2?.requiredFields || [];
	const optional = template?.authSchemaV2?.optionalFields || [];

	if (!required.length && !optional.length) {
		return <div className="js-muted">This template needs no credentials.</div>;
	}

	const renderField = (f, isRequired) => {
		const masked = isEdit || isSecretAuthKey(f.key);
		const InputComp = masked ? Input.Password : Input;
		return (
			<div className="ei-fitem" key={f.key}>
				<span className="ei-flabel">
					{f.label || f.key}
					{isRequired && !isEdit ? <span className="ei-field-req"> *</span> : null}
				</span>
				<InputComp
					value={auth[f.key] || ''}
					placeholder={isEdit ? '•••••••• (leave blank to keep)' : `Enter ${f.label || f.key}`}
					onChange={(e) => set(f.key, e.target.value)}
					autoComplete="new-password"
				/>
				{f.description ? <span className="ei-field-hint">{f.description}</span> : null}
			</div>
		);
	};

	return (
		<div className="ei-fgrid">
			{required.map((f) => renderField(f, true))}
			{optional.map((f) => renderField(f, false))}
		</div>
	);
}
